import './addUser.scss';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../../components/navbar/Navbar';
import { useState } from 'react';
// Staff accounts are created by the BACKEND (Admin SDK): it writes the
// Firebase Auth account, the Firestore role doc (client writes are denied
// by security rules) and the Postgres staff row together — and the
// super-user's own session is never disturbed.
import { apiService } from '../../services/api';

const AddUser = () => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [isUserAdded, setIsUserAdded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateFields = () => {
    let tempErrors = {};
    if (!data.name) tempErrors.name = 'Please enter a name.';
    if (!data.username) tempErrors.username = 'Please enter a username.';
    if (!data.email) tempErrors.email = 'Please enter an email.';
    if (!data.password) tempErrors.password = 'Please enter a password.';
    else if (data.password.length < 10)
      tempErrors.password = 'Password must be at least 10 characters.';
    if (!data.role) tempErrors.role = 'Please select a role.';

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleAdd = async (e) => {
    e.preventDefault();

    setIsUserAdded(false);
    if (!validateFields()) return;

    try {
      setIsSubmitting(true);
      await apiService.createStaff({
        name: data.name,
        username: data.username,
        email: data.email,
        password: data.password,
        role: data.role,
      });

      setIsUserAdded(true);
      setData({});
      setErrors({});

      // Clear the form
      e.target.reset();
    } catch (error) {
      console.error('Error adding user:', error);
      const message =
        error.response?.data?.error || error.message || 'Failed to add user';
      setErrors({ submit: message });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="content">
          {isUserAdded && (
            <div className="user-added-notification">
              User added successfully!
            </div>
          )}
          {errors.submit && (
            <div className="error-notification">{errors.submit}</div>
          )}
          <h1>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20" aria-hidden="true">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            Add a Staff Account
          </h1>
          <form onSubmit={handleAdd} className="userForm">
            <div className="formInput">
              <label>Name</label>
              <input
                type="text"
                placeholder="John Doe"
                onChange={(e) => setData({ ...data, name: e.target.value })}
              />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="formInput">
              <label>Username</label>
              <input
                type="text"
                placeholder="Username"
                onChange={(e) => setData({ ...data, username: e.target.value })}
              />
              {errors.username && (
                <div className="error">{errors.username}</div>
              )}
            </div>
            <div className="formInput">
              <label>Email</label>
              <input
                type="email"
                placeholder="Email"
                onChange={(e) => setData({ ...data, email: e.target.value })}
              />
              {errors.email && <div className="error">{errors.email}</div>}
            </div>
            <div className="formInput">
              <label>Password</label>
              <input
                type="password"
                placeholder="Password"
                onChange={(e) => setData({ ...data, password: e.target.value })}
              />
              {errors.password && (
                <div className="error">{errors.password}</div>
              )}
            </div>
            <div className="formInput">
              <label>Role</label>
              <select
                onChange={(e) => setData({ ...data, role: e.target.value })}
              >
                <option value="">Select Role</option>
                <option value="super-user">Super User</option>
                <option value="admin">Admin</option>
                <option value="audit">Audit</option>
                <option value="compliance">Risk & Compliance</option>
              </select>
              {errors.role && <div className="error">{errors.role}</div>}
            </div>
            <div className="formButton">
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Adding…' : 'Add User'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
